// extracted by mini-css-extract-plugin
module.exports = {"container":"RouterLinkImageItem_container__X1Tn9","image":"RouterLinkImageItem_image__3DEjE"};